import { render } from "./InvoiceIndex.vue?vue&type=template&id=5975dcd4"
import script from "./InvoiceIndex.vue?vue&type=script&lang=js"
export * from "./InvoiceIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__